module.exports = __webpack_public_path__ + "img/BARRA_LOGOS-02.b377f743.png";